export default __webpack_public_path__ + "static/mob-img06-e807b038537ded5ee55f5028fedf6bd7.png";